import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./insights-section.css";
import { DateConvert } from "../../helper/DateConvert";
import { BaseUrl } from "../../helper/BaseUrl";
export default function InsightsSection({ initialData }) {
  const [allData, setAllData] = useState(initialData || []);
  // API Calling
  const fetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/blogs`, {
        method: 'GET',
      });
      const result = await response.json();
      if (result.blogs === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.blogs);

    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };
  useEffect(() => {
    fetcher();
  }, [])

  if (!allData) {
    return <div style={{ height: "100vh", width: "100%" }}></div>;
  }
  return (
    <section className="insights-section">
      <div className="container">
        <div className="insights-section-header">
          <h2 className="heading">Leadership Insights & Perspectives</h2>
          <Link className="default-btn insights-section-view-more" to="/blogs">
            View More
          </Link>
        </div>

        <div className="row insights-section-cards">
          {allData.slice(0,3).map((data, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <article className="insight-card">
                <img src={data?.thumbnail ? `${BaseUrl}${data.thumbnail}` : undefined} loading="lazy" className="img-responsive" alt={data?.alt_thumbnail} />
                <div className="insight-card-content">
                  <p className="insight-card-date">{DateConvert(data?.date)}</p>
                  <h3 >{data?.title?.slice(0, 40)}</h3>
                  <p className="insight-card-description"> {data?.brief?.slice(0, 100) + "..."}</p>
                  <Link className="insight-card-link" to={`/blogs/${data?.slug}`}>
                    Read More
                    <i className="fa-solid fa-arrow-right" aria-hidden="true" />
                  </Link>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
